<template>
<div ref = "services" class = "services-area">
  <div class = "section columns is-centered map-area" style = "margin: 0px">
    <div class = "column is-10">
    

<span class = "title"> Política de privacidad </span>
<br><br>
<p class = "has-text-justified is-size-6">

Protección de Datos en conjunción con la normativa aplicable: TOLDOS HUERTABAJO, como responsable de la presente web y de conformidad con lo dispuesto en la Ley Orgánica 15/1999, de 13 de diciembre, de Protección de Datos de Carácter Personal y en la Ley 34/2002, de 11 de junio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, ha puesto en práctica políticas, medios y procedimientos para garantizar y proteger la privacidad de los datos de carácter personal de sus USUARIOS.
<br>
Identidad y dirección del responsable del fichero. El titular y responsable del fichero es TOLDOS HUERTABAJO.
<br>
Servicios prestados a través del sitio web. A través de las distintas áreas que forman parte de la presente web, los USUARIOS pueden obtener información, consultar y contratar servicios ofrecidos en el sitio web. La simple navegación por la web tiene carácter gratuito y no exige el registro previo por parte de los USUARIOS.
<br>
Los únicos datos personales a los que el responsable del fichero tendrá acceso serán aquellos que le sean facilitados voluntariamente a fin de posibilitar el acceso, uso o contratación de los servicios facilitados a través del sitio web.
<br>
Tratamiento de los datos y su confidencialidad. Los datos que se faciliten no se guardarán de manera alguna en el sistema. TOLDOS HUERTABAJO se compromete a utilizar la información ofrecida y no guardarla en sus sistemas.
<br>
No obstante, se advierte e informa a los USUARIOS que las medidas técnicas no son infalibles ni inexpugnables, motivo por el cual, el responsable del fichero no podrá tenerse por responsable de tales prácticas ni de sus consecuencias. Al remitir el interesado sus datos de carácter personal y correo electrónico a TOLDOS HUERTABAJO, expresamente AUTORIZA para la utilización de dichos datos a los efectos de las comunicaciones periódicas, incluyendo expresamente las que se realicen vía correo electrónico, que TOLDOS HUERTABAJO o las entidades filiales de TOLDOS HUERTABAJO lleven a cabo con sus clientes, colaboradores y posibles interesados, informándoles de sus actividades, noticias, promociones, así como de cualquier oferta de servicios y productos relacionados con la actividad que desarrolla.
<br>
El interesado podrá ejercitar respecto a sus datos los derechos de acceso, rectificación, cancelación y oposición, enviando un correo electrónico a la dirección electrónica toldoshuertabajo@gmail.com y solicitando, en su caso, que se le remitan por la misma vía sus datos personales que obren en los ficheros de TOLDOS HUERTABAJO a efectos de consulta, rectificación, cancelación o revocación de la autorización para la recepción de comunicaciones, debiendo notificar TOLDOS HUERTABAJO la efectiva rectificación o cancelación de los datos de carácter personal de su fichero. Los datos de carácter personal de los USUARIOS, junto con los que se originen como consecuencia del acceso, uso o contratación del servicio, solo podrán ser objeto de tratamiento automatizado y de cesión en la forma y con la finalidad establecida y expresamente autorizada por los USUARIOS.
<br>
Segmentación y categorización de los datos. El registro de los datos personales aportados en el momento de suscripción o compra de productos, y cualquier otro servicio facilitado durante su relación, comportará además la aceptación de carácter voluntario, por su parte, en relación al tratamiento de dichos datos personales por TOLDOS HUERTABAJO, a fin de ser segmentados o categorizados con la finalidad de aplicarlos a la actividad relacionada con la gestión de la administración general, la información, la comercialización de nuestros servicios, la elaboración de perfiles, el análisis de propuestas solicitadas por los USUARIOS o CLIENTES, y el estudio estadístico de los productos y contenidos utilizados, gustos y preferencias, encuestas o formularios.

</p>

<p class = "section subtitle has-text-weight-bold"> COMUNICACIÓN DE LOS DATOS </p>
<p class = "has-text-justified is-size-6">
Facilitar los datos personales por parte de los USUARIOS supone también la aceptación voluntaria y expresa de la cesión y transmisión de dichos datos, con iguales fines que los anteriormente indicados, a otras entidades del entorno de TOLDOS HUERTABAJO, auxiliares o colaboradoras, o ambas, así como la autorización al responsable del fichero para recibir de las citadas entidades del entorno de TOLDOS HUERTABAJO informaciones obrantes en sus archivos, incluso de forma interconectada, para las finalidades señaladas. En concreto, TOLDOS HUERTABAJO enviará a terceros información que permita su identificación cuando hayamos obtenido su permiso para compartir dicha información;necesitemos compartir dicha información para proporcionarle el producto que haya solicitado; necesitemos enviar dicha información a empresas que trabajan con TOLDOS HUERTABAJO para proporcionarle el producto o servicio que haya solicitado (a menos que le informemos de lo contrario, estas empresas no tienen derecho a utilizar la información de identificación que les suministremos más que en lo necesario para ayudarnos); respondamos a citaciones o requerimientos legales, así como a órdenes judiciales, o cuando estimemos que sus actividades en nuestro sitio web violan cualquiera de las instrucciones de uso de nuestros productos.
<br>
Derechos de los interesados y su ejercicio. Los USUARIOS tienen reconocida por la indicada Ley Orgánica de Protección de Datos de Carácter Personal los derechos de acceso, rectificación, cancelación y oposición, en su caso, respecto a sus datos personales, y al uso, categorización y segmentación de los datos de carácter personal. El interesado podrá ejercitar, respecto a sus datos, los derechos de acceso, rectificación, cancelación y oposición, enviando una carta a «Protección de datos TOLDOS HUERTABAJO. C/ Austria, 7 - 41800 Sanlúcar la mayor», o al correo electrónico toldoshuertabajo@gmail.com , solicitando, en su caso, que se le remitan por la misma vía sus datos personales que obren en los ficheros de TOLDOS HUERTABAJO, a los efectos de su consulta o su posible rectificación, o bien que se cancele o revoque la autorización para la recepción de comunicaciones, debiendo notificar TOLDOS HUERTABAJO la efectiva rectificación o cancelación de los datos de carácter personal de su fichero.
</p>
<p class = "section subtitle has-text-weight-bold"> POLÍTICA ANTISPAM </p>
<p class = "has-text-justified is-size-6">
Las personas que reciben algún tipo de de comunicación, información, boletín o publicidad electrónica de www.toldoshuertabajo.com las reciben por los siguientes motivos:
<br><br>
— Por la solicitud de información de nuestros productos y servicios.
<br><br>
Nuestras comunicaciones no quieren llegar a ninguna persona que no lo desee. Por ello, y para poder corregir la situación que a veces puede darse de que alguna persona pueda dar de alta a otra sin su consentimiento, puede contactar con nosotros en el teléfono 651 45 32 87 en horario de oficina, donde una persona le atenderá personalmente y realizará dicho trámite.
</p>
    
    </div>
  </div>
</div>
</template>

<script>

//import {requester} from '../App.vue';
//import _ from 'lodash';

export default {
  name: 'Services',
  data() {
    return { 
      name: ""
    }
  },
  methods: {
    goTo: function(){
      var element = this.$refs["services"];
      var top = element.offsetTop;

      window.scrollTo(0, top);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.services-area {
  background-color: #B4D9ED;
}
.list-area {
  background-color: rgb(147, 189, 212);
}

.title-font {
  font-family: "Baloo Bhaina 2";
}

h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
  font-family: 'Century Gothic', 'Tahoma', 'Verdana'
}
.list-style {
  /*display: inline-table;
  vertical-align: middle;*/
  list-style-position: inside;
  padding: 2px;
}
.image.is-256x256 {
  height: 256px;
  width: 256px;
}

.image.image-side {
  height: 270px;
  width: 480px;
}

.image-center {
  justify-content: center;
}
</style>

